import { __assign, __extends } from "tslib";
import { SESServiceException as __BaseException } from "./SESServiceException";
var AccountSendingPausedException = (function (_super) {
    __extends(AccountSendingPausedException, _super);
    function AccountSendingPausedException(opts) {
        var _this = _super.call(this, __assign({ name: "AccountSendingPausedException", $fault: "client" }, opts)) || this;
        _this.name = "AccountSendingPausedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccountSendingPausedException.prototype);
        return _this;
    }
    return AccountSendingPausedException;
}(__BaseException));
export { AccountSendingPausedException };
var AlreadyExistsException = (function (_super) {
    __extends(AlreadyExistsException, _super);
    function AlreadyExistsException(opts) {
        var _this = _super.call(this, __assign({ name: "AlreadyExistsException", $fault: "client" }, opts)) || this;
        _this.name = "AlreadyExistsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AlreadyExistsException.prototype);
        _this.Name = opts.Name;
        return _this;
    }
    return AlreadyExistsException;
}(__BaseException));
export { AlreadyExistsException };
export var BehaviorOnMXFailure;
(function (BehaviorOnMXFailure) {
    BehaviorOnMXFailure["RejectMessage"] = "RejectMessage";
    BehaviorOnMXFailure["UseDefaultValue"] = "UseDefaultValue";
})(BehaviorOnMXFailure || (BehaviorOnMXFailure = {}));
export var BounceType;
(function (BounceType) {
    BounceType["ContentRejected"] = "ContentRejected";
    BounceType["DoesNotExist"] = "DoesNotExist";
    BounceType["ExceededQuota"] = "ExceededQuota";
    BounceType["MessageTooLarge"] = "MessageTooLarge";
    BounceType["TemporaryFailure"] = "TemporaryFailure";
    BounceType["Undefined"] = "Undefined";
})(BounceType || (BounceType = {}));
export var DsnAction;
(function (DsnAction) {
    DsnAction["DELAYED"] = "delayed";
    DsnAction["DELIVERED"] = "delivered";
    DsnAction["EXPANDED"] = "expanded";
    DsnAction["FAILED"] = "failed";
    DsnAction["RELAYED"] = "relayed";
})(DsnAction || (DsnAction = {}));
export var BulkEmailStatus;
(function (BulkEmailStatus) {
    BulkEmailStatus["AccountDailyQuotaExceeded"] = "AccountDailyQuotaExceeded";
    BulkEmailStatus["AccountSendingPaused"] = "AccountSendingPaused";
    BulkEmailStatus["AccountSuspended"] = "AccountSuspended";
    BulkEmailStatus["AccountThrottled"] = "AccountThrottled";
    BulkEmailStatus["ConfigurationSetDoesNotExist"] = "ConfigurationSetDoesNotExist";
    BulkEmailStatus["ConfigurationSetSendingPaused"] = "ConfigurationSetSendingPaused";
    BulkEmailStatus["Failed"] = "Failed";
    BulkEmailStatus["InvalidParameterValue"] = "InvalidParameterValue";
    BulkEmailStatus["InvalidSendingPoolName"] = "InvalidSendingPoolName";
    BulkEmailStatus["MailFromDomainNotVerified"] = "MailFromDomainNotVerified";
    BulkEmailStatus["MessageRejected"] = "MessageRejected";
    BulkEmailStatus["Success"] = "Success";
    BulkEmailStatus["TemplateDoesNotExist"] = "TemplateDoesNotExist";
    BulkEmailStatus["TransientFailure"] = "TransientFailure";
})(BulkEmailStatus || (BulkEmailStatus = {}));
var CannotDeleteException = (function (_super) {
    __extends(CannotDeleteException, _super);
    function CannotDeleteException(opts) {
        var _this = _super.call(this, __assign({ name: "CannotDeleteException", $fault: "client" }, opts)) || this;
        _this.name = "CannotDeleteException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CannotDeleteException.prototype);
        _this.Name = opts.Name;
        return _this;
    }
    return CannotDeleteException;
}(__BaseException));
export { CannotDeleteException };
var LimitExceededException = (function (_super) {
    __extends(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "LimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        return _this;
    }
    return LimitExceededException;
}(__BaseException));
export { LimitExceededException };
var RuleSetDoesNotExistException = (function (_super) {
    __extends(RuleSetDoesNotExistException, _super);
    function RuleSetDoesNotExistException(opts) {
        var _this = _super.call(this, __assign({ name: "RuleSetDoesNotExistException", $fault: "client" }, opts)) || this;
        _this.name = "RuleSetDoesNotExistException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, RuleSetDoesNotExistException.prototype);
        _this.Name = opts.Name;
        return _this;
    }
    return RuleSetDoesNotExistException;
}(__BaseException));
export { RuleSetDoesNotExistException };
export var DimensionValueSource;
(function (DimensionValueSource) {
    DimensionValueSource["EMAIL_HEADER"] = "emailHeader";
    DimensionValueSource["LINK_TAG"] = "linkTag";
    DimensionValueSource["MESSAGE_TAG"] = "messageTag";
})(DimensionValueSource || (DimensionValueSource = {}));
var ConfigurationSetAlreadyExistsException = (function (_super) {
    __extends(ConfigurationSetAlreadyExistsException, _super);
    function ConfigurationSetAlreadyExistsException(opts) {
        var _this = _super.call(this, __assign({ name: "ConfigurationSetAlreadyExistsException", $fault: "client" }, opts)) || this;
        _this.name = "ConfigurationSetAlreadyExistsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConfigurationSetAlreadyExistsException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        return _this;
    }
    return ConfigurationSetAlreadyExistsException;
}(__BaseException));
export { ConfigurationSetAlreadyExistsException };
export var ConfigurationSetAttribute;
(function (ConfigurationSetAttribute) {
    ConfigurationSetAttribute["DELIVERY_OPTIONS"] = "deliveryOptions";
    ConfigurationSetAttribute["EVENT_DESTINATIONS"] = "eventDestinations";
    ConfigurationSetAttribute["REPUTATION_OPTIONS"] = "reputationOptions";
    ConfigurationSetAttribute["TRACKING_OPTIONS"] = "trackingOptions";
})(ConfigurationSetAttribute || (ConfigurationSetAttribute = {}));
var ConfigurationSetDoesNotExistException = (function (_super) {
    __extends(ConfigurationSetDoesNotExistException, _super);
    function ConfigurationSetDoesNotExistException(opts) {
        var _this = _super.call(this, __assign({ name: "ConfigurationSetDoesNotExistException", $fault: "client" }, opts)) || this;
        _this.name = "ConfigurationSetDoesNotExistException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConfigurationSetDoesNotExistException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        return _this;
    }
    return ConfigurationSetDoesNotExistException;
}(__BaseException));
export { ConfigurationSetDoesNotExistException };
var ConfigurationSetSendingPausedException = (function (_super) {
    __extends(ConfigurationSetSendingPausedException, _super);
    function ConfigurationSetSendingPausedException(opts) {
        var _this = _super.call(this, __assign({ name: "ConfigurationSetSendingPausedException", $fault: "client" }, opts)) || this;
        _this.name = "ConfigurationSetSendingPausedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConfigurationSetSendingPausedException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        return _this;
    }
    return ConfigurationSetSendingPausedException;
}(__BaseException));
export { ConfigurationSetSendingPausedException };
var InvalidConfigurationSetException = (function (_super) {
    __extends(InvalidConfigurationSetException, _super);
    function InvalidConfigurationSetException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidConfigurationSetException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidConfigurationSetException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidConfigurationSetException.prototype);
        return _this;
    }
    return InvalidConfigurationSetException;
}(__BaseException));
export { InvalidConfigurationSetException };
export var EventType;
(function (EventType) {
    EventType["BOUNCE"] = "bounce";
    EventType["CLICK"] = "click";
    EventType["COMPLAINT"] = "complaint";
    EventType["DELIVERY"] = "delivery";
    EventType["OPEN"] = "open";
    EventType["REJECT"] = "reject";
    EventType["RENDERING_FAILURE"] = "renderingFailure";
    EventType["SEND"] = "send";
})(EventType || (EventType = {}));
var EventDestinationAlreadyExistsException = (function (_super) {
    __extends(EventDestinationAlreadyExistsException, _super);
    function EventDestinationAlreadyExistsException(opts) {
        var _this = _super.call(this, __assign({ name: "EventDestinationAlreadyExistsException", $fault: "client" }, opts)) || this;
        _this.name = "EventDestinationAlreadyExistsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EventDestinationAlreadyExistsException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        _this.EventDestinationName = opts.EventDestinationName;
        return _this;
    }
    return EventDestinationAlreadyExistsException;
}(__BaseException));
export { EventDestinationAlreadyExistsException };
var InvalidCloudWatchDestinationException = (function (_super) {
    __extends(InvalidCloudWatchDestinationException, _super);
    function InvalidCloudWatchDestinationException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidCloudWatchDestinationException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidCloudWatchDestinationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidCloudWatchDestinationException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        _this.EventDestinationName = opts.EventDestinationName;
        return _this;
    }
    return InvalidCloudWatchDestinationException;
}(__BaseException));
export { InvalidCloudWatchDestinationException };
var InvalidFirehoseDestinationException = (function (_super) {
    __extends(InvalidFirehoseDestinationException, _super);
    function InvalidFirehoseDestinationException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidFirehoseDestinationException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidFirehoseDestinationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidFirehoseDestinationException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        _this.EventDestinationName = opts.EventDestinationName;
        return _this;
    }
    return InvalidFirehoseDestinationException;
}(__BaseException));
export { InvalidFirehoseDestinationException };
var InvalidSNSDestinationException = (function (_super) {
    __extends(InvalidSNSDestinationException, _super);
    function InvalidSNSDestinationException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidSNSDestinationException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidSNSDestinationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidSNSDestinationException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        _this.EventDestinationName = opts.EventDestinationName;
        return _this;
    }
    return InvalidSNSDestinationException;
}(__BaseException));
export { InvalidSNSDestinationException };
var InvalidTrackingOptionsException = (function (_super) {
    __extends(InvalidTrackingOptionsException, _super);
    function InvalidTrackingOptionsException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidTrackingOptionsException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidTrackingOptionsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidTrackingOptionsException.prototype);
        return _this;
    }
    return InvalidTrackingOptionsException;
}(__BaseException));
export { InvalidTrackingOptionsException };
var TrackingOptionsAlreadyExistsException = (function (_super) {
    __extends(TrackingOptionsAlreadyExistsException, _super);
    function TrackingOptionsAlreadyExistsException(opts) {
        var _this = _super.call(this, __assign({ name: "TrackingOptionsAlreadyExistsException", $fault: "client" }, opts)) || this;
        _this.name = "TrackingOptionsAlreadyExistsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TrackingOptionsAlreadyExistsException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        return _this;
    }
    return TrackingOptionsAlreadyExistsException;
}(__BaseException));
export { TrackingOptionsAlreadyExistsException };
var CustomVerificationEmailInvalidContentException = (function (_super) {
    __extends(CustomVerificationEmailInvalidContentException, _super);
    function CustomVerificationEmailInvalidContentException(opts) {
        var _this = _super.call(this, __assign({ name: "CustomVerificationEmailInvalidContentException", $fault: "client" }, opts)) || this;
        _this.name = "CustomVerificationEmailInvalidContentException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CustomVerificationEmailInvalidContentException.prototype);
        return _this;
    }
    return CustomVerificationEmailInvalidContentException;
}(__BaseException));
export { CustomVerificationEmailInvalidContentException };
var CustomVerificationEmailTemplateAlreadyExistsException = (function (_super) {
    __extends(CustomVerificationEmailTemplateAlreadyExistsException, _super);
    function CustomVerificationEmailTemplateAlreadyExistsException(opts) {
        var _this = _super.call(this, __assign({ name: "CustomVerificationEmailTemplateAlreadyExistsException", $fault: "client" }, opts)) || this;
        _this.name = "CustomVerificationEmailTemplateAlreadyExistsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CustomVerificationEmailTemplateAlreadyExistsException.prototype);
        _this.CustomVerificationEmailTemplateName = opts.CustomVerificationEmailTemplateName;
        return _this;
    }
    return CustomVerificationEmailTemplateAlreadyExistsException;
}(__BaseException));
export { CustomVerificationEmailTemplateAlreadyExistsException };
var FromEmailAddressNotVerifiedException = (function (_super) {
    __extends(FromEmailAddressNotVerifiedException, _super);
    function FromEmailAddressNotVerifiedException(opts) {
        var _this = _super.call(this, __assign({ name: "FromEmailAddressNotVerifiedException", $fault: "client" }, opts)) || this;
        _this.name = "FromEmailAddressNotVerifiedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, FromEmailAddressNotVerifiedException.prototype);
        _this.FromEmailAddress = opts.FromEmailAddress;
        return _this;
    }
    return FromEmailAddressNotVerifiedException;
}(__BaseException));
export { FromEmailAddressNotVerifiedException };
export var ReceiptFilterPolicy;
(function (ReceiptFilterPolicy) {
    ReceiptFilterPolicy["Allow"] = "Allow";
    ReceiptFilterPolicy["Block"] = "Block";
})(ReceiptFilterPolicy || (ReceiptFilterPolicy = {}));
export var SNSActionEncoding;
(function (SNSActionEncoding) {
    SNSActionEncoding["Base64"] = "Base64";
    SNSActionEncoding["UTF8"] = "UTF-8";
})(SNSActionEncoding || (SNSActionEncoding = {}));
export var StopScope;
(function (StopScope) {
    StopScope["RULE_SET"] = "RuleSet";
})(StopScope || (StopScope = {}));
export var TlsPolicy;
(function (TlsPolicy) {
    TlsPolicy["Optional"] = "Optional";
    TlsPolicy["Require"] = "Require";
})(TlsPolicy || (TlsPolicy = {}));
var InvalidLambdaFunctionException = (function (_super) {
    __extends(InvalidLambdaFunctionException, _super);
    function InvalidLambdaFunctionException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidLambdaFunctionException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidLambdaFunctionException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidLambdaFunctionException.prototype);
        _this.FunctionArn = opts.FunctionArn;
        return _this;
    }
    return InvalidLambdaFunctionException;
}(__BaseException));
export { InvalidLambdaFunctionException };
var InvalidS3ConfigurationException = (function (_super) {
    __extends(InvalidS3ConfigurationException, _super);
    function InvalidS3ConfigurationException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidS3ConfigurationException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidS3ConfigurationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidS3ConfigurationException.prototype);
        _this.Bucket = opts.Bucket;
        return _this;
    }
    return InvalidS3ConfigurationException;
}(__BaseException));
export { InvalidS3ConfigurationException };
var InvalidSnsTopicException = (function (_super) {
    __extends(InvalidSnsTopicException, _super);
    function InvalidSnsTopicException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidSnsTopicException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidSnsTopicException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidSnsTopicException.prototype);
        _this.Topic = opts.Topic;
        return _this;
    }
    return InvalidSnsTopicException;
}(__BaseException));
export { InvalidSnsTopicException };
var RuleDoesNotExistException = (function (_super) {
    __extends(RuleDoesNotExistException, _super);
    function RuleDoesNotExistException(opts) {
        var _this = _super.call(this, __assign({ name: "RuleDoesNotExistException", $fault: "client" }, opts)) || this;
        _this.name = "RuleDoesNotExistException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, RuleDoesNotExistException.prototype);
        _this.Name = opts.Name;
        return _this;
    }
    return RuleDoesNotExistException;
}(__BaseException));
export { RuleDoesNotExistException };
var InvalidTemplateException = (function (_super) {
    __extends(InvalidTemplateException, _super);
    function InvalidTemplateException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidTemplateException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidTemplateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidTemplateException.prototype);
        _this.TemplateName = opts.TemplateName;
        return _this;
    }
    return InvalidTemplateException;
}(__BaseException));
export { InvalidTemplateException };
export var CustomMailFromStatus;
(function (CustomMailFromStatus) {
    CustomMailFromStatus["Failed"] = "Failed";
    CustomMailFromStatus["Pending"] = "Pending";
    CustomMailFromStatus["Success"] = "Success";
    CustomMailFromStatus["TemporaryFailure"] = "TemporaryFailure";
})(CustomMailFromStatus || (CustomMailFromStatus = {}));
var CustomVerificationEmailTemplateDoesNotExistException = (function (_super) {
    __extends(CustomVerificationEmailTemplateDoesNotExistException, _super);
    function CustomVerificationEmailTemplateDoesNotExistException(opts) {
        var _this = _super.call(this, __assign({ name: "CustomVerificationEmailTemplateDoesNotExistException", $fault: "client" }, opts)) || this;
        _this.name = "CustomVerificationEmailTemplateDoesNotExistException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CustomVerificationEmailTemplateDoesNotExistException.prototype);
        _this.CustomVerificationEmailTemplateName = opts.CustomVerificationEmailTemplateName;
        return _this;
    }
    return CustomVerificationEmailTemplateDoesNotExistException;
}(__BaseException));
export { CustomVerificationEmailTemplateDoesNotExistException };
var EventDestinationDoesNotExistException = (function (_super) {
    __extends(EventDestinationDoesNotExistException, _super);
    function EventDestinationDoesNotExistException(opts) {
        var _this = _super.call(this, __assign({ name: "EventDestinationDoesNotExistException", $fault: "client" }, opts)) || this;
        _this.name = "EventDestinationDoesNotExistException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EventDestinationDoesNotExistException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        _this.EventDestinationName = opts.EventDestinationName;
        return _this;
    }
    return EventDestinationDoesNotExistException;
}(__BaseException));
export { EventDestinationDoesNotExistException };
var TrackingOptionsDoesNotExistException = (function (_super) {
    __extends(TrackingOptionsDoesNotExistException, _super);
    function TrackingOptionsDoesNotExistException(opts) {
        var _this = _super.call(this, __assign({ name: "TrackingOptionsDoesNotExistException", $fault: "client" }, opts)) || this;
        _this.name = "TrackingOptionsDoesNotExistException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TrackingOptionsDoesNotExistException.prototype);
        _this.ConfigurationSetName = opts.ConfigurationSetName;
        return _this;
    }
    return TrackingOptionsDoesNotExistException;
}(__BaseException));
export { TrackingOptionsDoesNotExistException };
var TemplateDoesNotExistException = (function (_super) {
    __extends(TemplateDoesNotExistException, _super);
    function TemplateDoesNotExistException(opts) {
        var _this = _super.call(this, __assign({ name: "TemplateDoesNotExistException", $fault: "client" }, opts)) || this;
        _this.name = "TemplateDoesNotExistException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TemplateDoesNotExistException.prototype);
        _this.TemplateName = opts.TemplateName;
        return _this;
    }
    return TemplateDoesNotExistException;
}(__BaseException));
export { TemplateDoesNotExistException };
var InvalidDeliveryOptionsException = (function (_super) {
    __extends(InvalidDeliveryOptionsException, _super);
    function InvalidDeliveryOptionsException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidDeliveryOptionsException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidDeliveryOptionsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidDeliveryOptionsException.prototype);
        return _this;
    }
    return InvalidDeliveryOptionsException;
}(__BaseException));
export { InvalidDeliveryOptionsException };
var InvalidPolicyException = (function (_super) {
    __extends(InvalidPolicyException, _super);
    function InvalidPolicyException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidPolicyException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidPolicyException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidPolicyException.prototype);
        return _this;
    }
    return InvalidPolicyException;
}(__BaseException));
export { InvalidPolicyException };
var InvalidRenderingParameterException = (function (_super) {
    __extends(InvalidRenderingParameterException, _super);
    function InvalidRenderingParameterException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidRenderingParameterException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidRenderingParameterException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidRenderingParameterException.prototype);
        _this.TemplateName = opts.TemplateName;
        return _this;
    }
    return InvalidRenderingParameterException;
}(__BaseException));
export { InvalidRenderingParameterException };
var MailFromDomainNotVerifiedException = (function (_super) {
    __extends(MailFromDomainNotVerifiedException, _super);
    function MailFromDomainNotVerifiedException(opts) {
        var _this = _super.call(this, __assign({ name: "MailFromDomainNotVerifiedException", $fault: "client" }, opts)) || this;
        _this.name = "MailFromDomainNotVerifiedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MailFromDomainNotVerifiedException.prototype);
        return _this;
    }
    return MailFromDomainNotVerifiedException;
}(__BaseException));
export { MailFromDomainNotVerifiedException };
var MessageRejected = (function (_super) {
    __extends(MessageRejected, _super);
    function MessageRejected(opts) {
        var _this = _super.call(this, __assign({ name: "MessageRejected", $fault: "client" }, opts)) || this;
        _this.name = "MessageRejected";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MessageRejected.prototype);
        return _this;
    }
    return MessageRejected;
}(__BaseException));
export { MessageRejected };
var MissingRenderingAttributeException = (function (_super) {
    __extends(MissingRenderingAttributeException, _super);
    function MissingRenderingAttributeException(opts) {
        var _this = _super.call(this, __assign({ name: "MissingRenderingAttributeException", $fault: "client" }, opts)) || this;
        _this.name = "MissingRenderingAttributeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MissingRenderingAttributeException.prototype);
        _this.TemplateName = opts.TemplateName;
        return _this;
    }
    return MissingRenderingAttributeException;
}(__BaseException));
export { MissingRenderingAttributeException };
var ProductionAccessNotGrantedException = (function (_super) {
    __extends(ProductionAccessNotGrantedException, _super);
    function ProductionAccessNotGrantedException(opts) {
        var _this = _super.call(this, __assign({ name: "ProductionAccessNotGrantedException", $fault: "client" }, opts)) || this;
        _this.name = "ProductionAccessNotGrantedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ProductionAccessNotGrantedException.prototype);
        return _this;
    }
    return ProductionAccessNotGrantedException;
}(__BaseException));
export { ProductionAccessNotGrantedException };
export var AddHeaderActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ContentFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BodyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BounceActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ExtensionFieldFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RecipientDsnFieldsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BouncedRecipientInfoFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DestinationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MessageTagFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BulkEmailDestinationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BulkEmailDestinationStatusFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CloneReceiptRuleSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CloneReceiptRuleSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CloudWatchDimensionConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CloudWatchDestinationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConfigurationSetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConfigurationSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConfigurationSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KinesisFirehoseDestinationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SNSDestinationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EventDestinationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConfigurationSetEventDestinationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConfigurationSetEventDestinationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TrackingOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConfigurationSetTrackingOptionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConfigurationSetTrackingOptionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCustomVerificationEmailTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReceiptIpFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReceiptFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateReceiptFilterRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateReceiptFilterResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LambdaActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3ActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SNSActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var WorkmailActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReceiptActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReceiptRuleFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateReceiptRuleRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateReceiptRuleResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateReceiptRuleSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateReceiptRuleSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TemplateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTemplateResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CustomVerificationEmailTemplateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConfigurationSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConfigurationSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConfigurationSetEventDestinationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConfigurationSetEventDestinationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConfigurationSetTrackingOptionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConfigurationSetTrackingOptionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCustomVerificationEmailTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteIdentityRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteIdentityResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteIdentityPolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteIdentityPolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteReceiptFilterRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteReceiptFilterResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteReceiptRuleRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteReceiptRuleResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteReceiptRuleSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteReceiptRuleSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTemplateResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteVerifiedEmailAddressRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeliveryOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeActiveReceiptRuleSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReceiptRuleSetMetadataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeActiveReceiptRuleSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeConfigurationSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReputationOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeConfigurationSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeReceiptRuleRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeReceiptRuleResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeReceiptRuleSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeReceiptRuleSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var IdentityDkimAttributesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetAccountSendingEnabledResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCustomVerificationEmailTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCustomVerificationEmailTemplateResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityDkimAttributesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityDkimAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityMailFromDomainAttributesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var IdentityMailFromDomainAttributesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityMailFromDomainAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityNotificationAttributesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var IdentityNotificationAttributesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityNotificationAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityPoliciesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityPoliciesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityVerificationAttributesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var IdentityVerificationAttributesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetIdentityVerificationAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSendQuotaResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendDataPointFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSendStatisticsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTemplateResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListConfigurationSetsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListConfigurationSetsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCustomVerificationEmailTemplatesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCustomVerificationEmailTemplatesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListIdentitiesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListIdentitiesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListIdentityPoliciesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListIdentityPoliciesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListReceiptFiltersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListReceiptFiltersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListReceiptRuleSetsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListReceiptRuleSetsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTemplatesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TemplateMetadataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTemplatesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListVerifiedEmailAddressesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MessageFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MessageDsnFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutConfigurationSetDeliveryOptionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutConfigurationSetDeliveryOptionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutIdentityPolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutIdentityPolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RawMessageFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReorderReceiptRuleSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ReorderReceiptRuleSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendBounceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendBounceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendBulkTemplatedEmailRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendBulkTemplatedEmailResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendCustomVerificationEmailRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendCustomVerificationEmailResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendEmailRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendEmailResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendRawEmailRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendRawEmailResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendTemplatedEmailRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SendTemplatedEmailResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetActiveReceiptRuleSetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetActiveReceiptRuleSetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityDkimEnabledRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityDkimEnabledResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityFeedbackForwardingEnabledRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityFeedbackForwardingEnabledResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityHeadersInNotificationsEnabledRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityHeadersInNotificationsEnabledResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityMailFromDomainRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityMailFromDomainResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityNotificationTopicRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetIdentityNotificationTopicResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetReceiptRulePositionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetReceiptRulePositionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TestRenderTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TestRenderTemplateResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateAccountSendingEnabledRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConfigurationSetEventDestinationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConfigurationSetEventDestinationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConfigurationSetReputationMetricsEnabledRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConfigurationSetSendingEnabledRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConfigurationSetTrackingOptionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConfigurationSetTrackingOptionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCustomVerificationEmailTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateReceiptRuleRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateReceiptRuleResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateTemplateRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateTemplateResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifyDomainDkimRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifyDomainDkimResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifyDomainIdentityRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifyDomainIdentityResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifyEmailAddressRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifyEmailIdentityRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifyEmailIdentityResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
